import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import Logo from './Logo';
import Birthday24 from './Logo.dabirthday_24';
export default withFeatureBranch({
    dabirthday_24: Birthday24
})(Logo);

//# sourceMappingURL=index.js.map